<template>
  <!-- 상담 신청 다이얼로그 -->
  <v-dialog v-model="dialog"
            :width="isMobile ? undefined : '600px'"
            :fullscreen="isMobile"
            :hide-overlay="isMobile"
            :transition="isMobile ? 'dialog-bottom-transition' : undefined"
            :persistent="isMobile"
  >
    <v-card>
      <v-toolbar flat>
        <v-btn icon @click.stop="dialog = false">
          <v-icon>$vuetify.icons.cancel</v-icon>
        </v-btn>
        <h3 class="display-2" style="margin-bottom: 2px">알림 신청</h3>
      </v-toolbar>

      <v-form v-model="visitMeta.valid">
        <v-layout row wrap pa-5 mt-5 class="text-xs-left visit-form">
          <v-flex xs12 mb-5 class="text-xs-center">
            <h2>알림신청을 위해 필요한<br>정보를 입력해주세요.</h2>
          </v-flex>

          <v-flex xs12>
            <h3 class="mb-3">필수 정보를 입력해주세요.</h3>
            <v-text-field label="이름"
                          placeholder="이름"
                          v-model="visitInfo.name"
                          :rules="[rules.required]"
                          required>
            </v-text-field>
          </v-flex>
          <v-flex xs12>
            <v-text-field label="휴대폰 번호"
                          placeholder="000-0000-0000"
                          :rules="[rules.required]"
                          :mask="phoneMask"
                          v-model="visitInfo.phone"
                          required></v-text-field>
          </v-flex>

          <v-flex xs12>
            <v-expansion-panel class="expansion-panel-form">
              <v-expansion-panel-content>
                <template v-slot:actions>
                  <v-icon>$vuetify.icons.arrowDown</v-icon>
                </template>
                <template v-slot:header>
                  <v-checkbox on-icon="$vuetify.icons.confirm"
                              off-icon="$vuetify.icons.confirm"
                              color="primary"
                              class="pt-0"
                              style="margin-top: 10px;"
                              required
                              :rules="[rules.required]"
                              :ripple="false"
                              @click.stop
                              v-model="visitInfo.agreePrivacy">
                    <template v-slot:label>
                      <div style="font-size: 16px;">
                        <span>{{ privacyTerm.title }} 동의</span>
                        <span class="caption-form">&nbsp;[필수]</span>
                      </div>
                    </template>
                  </v-checkbox>
                </template>
                <div v-html="privacyTerm.content" class="pa-3" style="height: 400px; overflow-y: scroll; border: 1px solid #f4f4f4; border-radius: 10px;"></div>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-flex>

          <v-flex xs12>
            <v-btn color="#ec514f" class="mt-5" style="height: 56px; color: white;"
                   depressed
                   :disabled="!visitMeta.valid"
                   :loading="submitLoading"
                   block @click="submit">신청하기</v-btn>
          </v-flex>
        </v-layout>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import axios from 'axios';
import {mapActions, mapGetters} from 'vuex';
import terms from '@/assets/js/terms';

export default {
  name: 'AlarmDialog',
  props: {
    isMobile: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters([ 'alarmDialog' ]),
    ...mapGetters('user', { userIdx: 'idx' }),
    dialog: {
      get () {
        return this.alarmDialog;
      },
      set (flag) {
        this.toggleAlarmDialog(flag);
      }
    },
    phoneMask () {
      return this.visitInfo.phone.value && this.visitInfo.phone.value.length <= 10 ? '###-###-#####' : '###-####-####';
    },
    privacyTerm () {
      return terms.visitPrivacy;
    },
  },
  data () {
    return {
      submitLoading: false,
      visitMeta: {
        valid: false,
      },
      rules: {
        required: v => !!v || '필수사항입니다.',
        requiredMultiple: v => !!v.length || '필수사항입니다.'
      },
      visitInfo: {
        name: '',
        phone: '',
      },
    };
  },
  methods: {
    ...mapActions([ 'toggleAlarmDialog' ]),
    postForm (name, phone) {
      return new Promise((resolve, reject) => {
        axios.get(`https://script.google.com/macros/s/AKfycbyLSh-FcrRYTqd-_BfTHxl0PsU7GYbKHae1VAYm4g0aqMPrsVQ/exec`, {
          params: {
            name,
            phone
          },
          headers: {
            'Content-Type': 'application/json;charset=utf-8',
          },
        }).then(response => {
          if (response.data) resolve(response.data);
          reject(response);
        }).catch(reject);
      });
    },
    submit () {
      this.submitLoading = true;
      this.postForm(this.visitInfo.name, this.visitInfo.phone).then(response => {
        console.log(response);
        this.visitInfo = {
          name: '',
          phone: '',
        };
        alert('알림이 신청되었습니다 👏');
        this.submitLoading = false;
        this.dialog = false;
      }).catch(err => {
        console.error(err);
        alert('오류가 발생했어요 😢 잠시 후 다시 시도해 주세요.');
        this.submitLoading = false;
      });
    },
  }
}
</script>

<style lang="scss" scoped>
::v-deep.visit-form {
  .v-input__slot::before {
    border-color: #f4f4f4 !important;
  }
}
::v-deep.flat-calendar {
  box-shadow: none;
  .v-date-picker-table {
    padding: 0;
    height: auto;
  }
}
::v-deep.expansion-panel-form {
  box-shadow: none;
  .v-expansion-panel__header {
    padding: 12px 0;
  }
}
::v-deep.v-input--checkbox {
  .v-input__slot {
    margin-bottom: 0 !important;
  }
  .v-messages {
    min-height: 12px;
  }
  i {
    margin: auto;
    font-size: 16px;
  }
  input[aria-checked=false] ~ i {
    color: #cdcdcd !important;
  }
}
</style>
